var _ellipse, _circle, _ellipse2, _ellipse3, _ellipse4, _circle2, _circle3, _ellipse5, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlodots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99967,
    cy: 4.16667,
    rx: 1.66667,
    ry: 1.66667,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99967,
    cy: 10.0002,
    r: 1.66667,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99967,
    cy: 15.8332,
    rx: 1.66667,
    ry: 1.66667,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.8337,
    cy: 4.16667,
    rx: 1.66667,
    ry: 1.66667,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.8337,
    cy: 10.0002,
    rx: 1.66667,
    ry: 1.66667,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8337,
    cy: 15.8332,
    r: 1.66667,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.16667,
    cy: 4.16667,
    r: 1.66667,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.16667,
    cy: 10.0002,
    rx: 1.66667,
    ry: 1.66667,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.16667,
    cy: 15.8332,
    rx: 1.66667,
    ry: 1.66667,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlodots);
export default __webpack_public_path__ + "static/media/ilodots.92786abe6a81bfe85fd7ee0391fb2ef4.svg";
export { ForwardRef as ReactComponent };